import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORT_API } from "../../apis/report";

export const fetchStatisticReport = createAsyncThunk(
    'report/fetchStatisticReport',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getStatisticReport(params);
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch report statistic');
        }
    }
)

export const fetchPhanAnhTheoThang = createAsyncThunk(
    'report/fetchPhanAnhTheoThang',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getPhanAnhTheoThang(params);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || error?.message || 'Lấy báo cáo phản ánh theo tháng thất bại');
        }
    }
)

export const fetchReportPagination = createAsyncThunk(
    'report/fetchReportPagination',
    async ({
        idLinhVucPhanAnh = '',
        trangThai = '',
        tinhTrang = '',
        slaStatus = '',
        mucDo = '',
        khuPho = '',
        startDate = '',
        endDate = '',
        page = 1,
        size = 10,
        maPhanAnh = '',
        sortTime = '',
        sortBy = '',
        sortOrder = '',
    }, { rejectWithValue }) => {
        try {
            const params = {
                page,
                size
            };

            if (idLinhVucPhanAnh) params.idLinhVucPhanAnh = idLinhVucPhanAnh;
            if (trangThai) params.trangThai = trangThai;
            if (slaStatus || tinhTrang) params.slaStatus = slaStatus || tinhTrang;
            if (mucDo) params.mucDo = mucDo;
            if (khuPho) params.khuPho = khuPho;
            if (startDate) params.startDate = startDate;
            if (endDate) params.endDate = endDate;
            if (maPhanAnh) params.maPhanAnh = maPhanAnh;
            if (sortBy) params.sortBy = sortBy;
            if (sortOrder) params.sortOrder = sortOrder;
            if (sortTime) params.sortTime = sortTime;

            const response = await REPORT_API.getReportPagination(params);

            return {
                content: Array.isArray(response.data) ? response.data : [],
                page: Number(response.pagination?.currentPage) || page,
                size: Number(response.pagination?.pageSize) || size,
                totalElements: Number(response.pagination?.totalItems) || 0,
                totalPages: Number(response.pagination?.totalPages) || 0,
                stats: response.stats || response.pagination?.stats || null,
            };
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch procedures');
        }
    }
)

export const fetchHistoryStatus = createAsyncThunk(
    'report/fetchHistoryStatus',
    async (reportId, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getHistoryStatus(reportId);
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch history status');
        }
    }
)

export const fetchExtent = createAsyncThunk(
    'report/fetchExtent',
    async (_, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getExtent();
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch extent');
        }
    }
)

export const fetchStatusReport = createAsyncThunk(
    'report/fetchStatusReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getStatusReport();
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch status report');
        }
    }
)

export const fetchReportById = createAsyncThunk(
    'report/fetchReportById',
    async (reportId, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getReportById(reportId);
            return response;
        } catch (error) {
            return rejectWithValue(error.message || 'Failed to fetch report by ID');
        }
    }
)

export const updateReportStatus = createAsyncThunk(
    'report/updateReportStatus',
    async ({ reportId, statusData }, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.updateStatusReport(reportId, statusData);
            return { reportId, updatedData: response };
        } catch (error) {
                return rejectWithValue(error?.response?.data?.message || error?.message || 'Cập nhật trạng thái thất bại');
        }
    }
)

export const updateReportLinhVuc = createAsyncThunk(
    'report/updateReportLinhVuc',
    async ({ reportId, idLinhVucPhanAnh, lyDo }, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.updateLinhVucReport(reportId, idLinhVucPhanAnh, lyDo);
            return { reportId, updatedData: response };
        } catch (error) {
            return rejectWithValue(error?.message || 'Cập nhật lĩnh vực phản ánh thất bại');
        }
    }
)

export const fetchAssignableUsers = createAsyncThunk(
    'report/fetchAssignableUsers',
    async (reportId, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.getAssignableUsers(reportId);
            return response;
        } catch (error) {
            return rejectWithValue(error?.message || 'Lấy danh sách chuyên viên xử lý thất bại');
        }
    }
)

export const assignReportNguoiXuLy = createAsyncThunk(
    'report/assignReportNguoiXuLy',
    async ({ reportId, idNguoiXuLy, lyDo }, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.assignReport(reportId, idNguoiXuLy, lyDo);
            return { reportId, updatedData: response };
        } catch (error) {
            return rejectWithValue(error?.message || 'Phân công xử lý phản ánh thất bại');
        }
    }
)

export const createNewReport = createAsyncThunk(
    'report/createNewReport',
    async (reportData, { rejectWithValue }) => {
        try {
            const response = await REPORT_API.createReport(reportData);
            return response;
        } catch (error) {
            return rejectWithValue(error?.message || 'Tạo phản ánh thất bại');
        }
    }
)